import * as React from 'react';

import { Row as AntRow } from 'antd';

export type RowProps = {
  // TODO
};

const Row = (props: RowProps & React.ComponentProps<typeof AntRow>) => {
  const { className } = props;
  const classNames = [className, 'row'].filter((name) => name);
  return <AntRow {...props} className={classNames.join(' ')} />;
};

Row.defaultProps = {
  // TODO
};

export default Row;
